import EmailExportHtml from '../../app-lite/export/templates/email-export.html';

export function ExportCtrl ($scope, $window, $translate, $uibModal, messages, sessionObjAPI, workshopAPI) {
  $scope.loaded     = true;
  $scope.company    = sessionObjAPI.company();
  $scope.offset     = 0;
  $scope.limit      = 0;
  $scope.start_date = '*';
  $scope.end_date   = '*';

  $scope.today = function() {
    var fullDate = new Date();
    var date     = fullDate.getDate();
    var month    = fullDate.getMonth() + 1;
    var year     = fullDate.getFullYear();

    return sprintf('%1$s-%2$s-%3$s', date, month, year);
  };

  $scope.exportCustomer = function() {
    $uibModal.open({
      templateUrl: EmailExportHtml,
      controller : 'emailCustomerExportCtrl',
      windowClass: 'md-modal',
      resolve    : {
          company () {
            return $scope.company;
          },
          limited () {
            return true;
          }
        }
    }).result;
  };

  $scope.exportVendor = function() {
    $uibModal.open({
      templateUrl: EmailExportHtml,
      controller : 'emailVendorExportCtrl',
      windowClass: 'md-modal',
      resolve    : {
          company () {
            return $scope.company;
          },
          limited () {
            return true;
          }
        }
    }).result;
  };

  $scope.exportProduct = function() {
    $uibModal.open({
      templateUrl: EmailExportHtml,
      controller : 'emailProductExportCtrl',
      windowClass: 'md-modal',
      resolve    : {
          company () {
            return $scope.company;
          },
          limited () {
            return true;
          },
          product_offset: function() {
            return $scope.offset;
          },
          product_limit: function() {
            return $scope.limit;
          }
      }
    }).result;
  };

  $scope.exportVehicle = function() {
    $uibModal.open({
      templateUrl: EmailExportHtml,
      controller : 'emailVehicleExportCtrl',
      windowClass: 'md-modal',
      resolve    : {
          company () {
            return $scope.company;
          },
          limited () {
            return true;
          }
        }
    }).result;
  };

  $scope.exportHistory = function() {
    $uibModal.open({
      templateUrl: EmailExportHtml,
      controller : 'emailInvoiceExportCtrl',
      windowClass: 'md-modal',
      resolve    : {
          company () {
            return $scope.company;
          },
          limited () {
            return true;
          },
          start_date: function() {
            return $scope.start_date;
          },
          end_date: function() {
            return $scope.end_date;
          }
        }
    }).result;

  };

  $scope.exportHistoryItem = function() {
    $uibModal.open({
      templateUrl: EmailExportHtml,
      controller : 'emailInvoiceItemExportCtrl',
      windowClass: 'md-modal',
      resolve    : {
          company () {
            return $scope.company;
          },
          limited () {
            return true;
          },
          start_date: function() {
            return $scope.start_date;
          },
          end_date: function() {
            return $scope.end_date;
          }
        }
    }).result;

  };
}